import {connect} from 'react-redux';
import {QCToolsMetadataState} from 'QCTools/QCToolsMetadata/QCToolsMetadataTypes';
import {
    setQcJobStateAction,
    resetQcJobStateAction,
    getDeliveryJobsStatusAction,
    deliveryJobAction,
    resetJobDeliveryStatusAction,
} from './Redux/QCToolsActions';
import {QcJobStatusIndicatorState} from './JobStatusIndicator/JobStatusIndicatorTypes';
import {
    resetQcToolsMetadataAction,
    setQcToolsMetadataAction,
} from './QCToolsMetadata/Redux/QCToolsMetadataActions';
import QCToolsContainer from './QCToolsContainer';
import {DeliveryJobsStatusPayload} from './QCToolsTypes';
import {Item, resetItemAction, setItemAction} from '../VideoAudioQC/QCMedia/Redux/QCMediaActions';
import {QCMediaState} from '../VideoAudioQC/QCMedia/Redux/QCMediaReducer';

export type State = {
    videoAudioQC: {
        qcMedia: QCMediaState,
    },
    qcTools: {
        statusIndicators: QcJobStatusIndicatorState,
        qcToolsMetadata: QCToolsMetadataState,
        jobDeliveryStatus: DeliveryJobsStatusPayload
    },
};

export interface QCToolsMapState extends QcJobStatusIndicatorState{
    isMetadataLoading: boolean;
    contentType: string | undefined;
    item: Item | null;
}

export const mapState = (state: State): QCToolsMapState => {
    const {qcTools} = state;
    const {item} = state.videoAudioQC.qcMedia;
    const {
        statusIndicators,
        qcToolsMetadata,
        jobDeliveryStatus,
    } = qcTools;
    const {
        isLoading: isMetadataLoading,
        general,
    } = qcToolsMetadata;
    const {contentType} = general;

    return {
        ...statusIndicators,
        ...jobDeliveryStatus,
        isMetadataLoading,
        contentType,
        item,
    };
};

const mapDispatch = {
    setQcJobState: setQcJobStateAction,
    resetQcJobState: resetQcJobStateAction,
    setQcMetadata: setQcToolsMetadataAction,
    resetQcMetadata: resetQcToolsMetadataAction,
    getDeliveryJobStatus: getDeliveryJobsStatusAction,
    resetJobDeliveryStatus: resetJobDeliveryStatusAction,
    deliveryJob: deliveryJobAction,
    setItem: setItemAction as any,
    resetItem: resetItemAction,
};

export default connect(mapState, mapDispatch)(QCToolsContainer);
